import _styled from "@emotion/styled/base";
import PropTypes from 'prop-types';
const Spacer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eh7hkix0"
} : {
  target: "eh7hkix0",
  label: "Spacer"
})("height:", _ref => {
  let {
    height
  } = _ref;
  return height;
}, "px;width:100%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvc3RydWN0dXJlL1NwYWNlci9TcGFjZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3lCIiwiZmlsZSI6Ii9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvc3RydWN0dXJlL1NwYWNlci9TcGFjZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkICAgIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5jb25zdCBTcGFjZXIgPSBzdHlsZWQuZGl2YFxuICBoZWlnaHQ6ICR7KHsgaGVpZ2h0IH0pID0+IGhlaWdodH1weDtcbiAgd2lkdGg6IDEwMCU7XG5gO1xuXG5TcGFjZXIucHJvcFR5cGVzID0ge1xuICBoZWlnaHQ6IFByb3BUeXBlcy5udW1iZXIsXG59O1xuXG5TcGFjZXIuZGVmYXVsdFByb3BzID0ge1xuICBoZWlnaHQ6IDYwLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU3BhY2VyO1xuIl19 */"));
Spacer.propTypes = {
  height: PropTypes.number
};
Spacer.defaultProps = {
  height: 60
};
export default Spacer;